import React from "react"
import Icon from "./Icon"

// AP-style press release document for "Halden Museum: Jazz & Abstracts" — Press channel hero.
// No event photo — pure document mock with letterhead, double-rule divider, dateline,
// pull quote, and end marker.

const PressReleaseDocument = () => (
  <div style={{ position: "relative", width: "100%", maxWidth: 460, margin: "0 auto" }}>
    {/* AI draft chip (top-left) */}
    <div style={{
      position: "absolute", top: -18, left: -30, zIndex: 4,
      padding: "8px 12px 8px 10px",
      background: "rgba(50,38,5,.78)",
      backdropFilter: "blur(14px)", WebkitBackdropFilter: "blur(14px)",
      border: "1px solid rgba(255,255,255,.14)",
      borderRadius: 10, color: "#fff",
      display: "flex", alignItems: "center", gap: 8,
      fontSize: 12, fontWeight: 600, whiteSpace: "nowrap",
      boxShadow: "0 10px 28px rgba(0,0,0,.28)",
      animation: "vsFloat 6s ease-in-out infinite",
    }}>
      <span style={{
        width: 18, height: 18, borderRadius: 5,
        background: "linear-gradient(135deg,#FF9500,#E6DB8A)",
        display: "flex", alignItems: "center", justifyContent: "center", color: "#fff",
      }}>
        <Icon name="sparkles" size={11} stroke={2.4}/>
      </span>
      <span>AI Draft · v3 of 3</span>
    </div>

    <div style={{
      position: "relative", zIndex: 2,
      background: "#FFFDF7", borderRadius: 12,
      boxShadow: "0 30px 80px rgba(60,45,5,.40), 0 10px 24px rgba(60,45,5,.22)",
      overflow: "hidden",
      transform: "perspective(1400px) rotateY(-6deg) rotateX(2deg)",
      transformOrigin: "center",
      fontFamily: "Georgia, 'Times New Roman', serif",
    }}>
      <div style={{
        padding: "18px 22px 14px",
        borderBottom: "3px double var(--mpp-accent)",
        display: "flex", alignItems: "center", justifyContent: "space-between",
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <div style={{
            width: 34, height: 34, borderRadius: 8,
            background: "var(--mpp-gradient)",
            color: "#fff", fontSize: 13, fontWeight: 800,
            display: "flex", alignItems: "center", justifyContent: "center",
            fontFamily: "Manrope, system-ui, sans-serif",
          }}>HM</div>
          <div style={{ lineHeight: 1.2 }}>
            <div style={{ fontSize: 12.5, fontWeight: 700, color: "#0F172A", fontFamily: "Manrope, system-ui, sans-serif" }}>The Halden Museum</div>
            <div style={{ fontSize: 10, color: "#6B5A2E", fontFamily: "Manrope, system-ui, sans-serif", letterSpacing: ".06em" }}>1421 W Division St · Chicago, IL 60622</div>
          </div>
        </div>
        <div style={{
          fontSize: 9, fontWeight: 800, letterSpacing: ".18em",
          color: "var(--mpp-accent)", fontFamily: "Manrope, system-ui, sans-serif",
          padding: "4px 9px", borderRadius: 4,
          background: "var(--mpp-accent-soft)",
        }}>PRESS RELEASE</div>
      </div>

      <div style={{ padding: "18px 22px 20px" }}>
        <div style={{
          fontSize: 9.5, fontWeight: 700, letterSpacing: ".14em", textTransform: "uppercase",
          color: "#8E3215", fontFamily: "Manrope, system-ui, sans-serif", marginBottom: 10,
        }}>
          For Immediate Release — April 18, 2026
        </div>

        <div style={{
          fontSize: 22, lineHeight: 1.15, fontWeight: 700, color: "#0F172A",
          letterSpacing: "-.01em", marginBottom: 6,
        }}>
          The Halden Museum Unveils Jazz & Abstracts, a Late-Night Celebration of Sound and Canvas
        </div>
        <div style={{
          fontSize: 13, lineHeight: 1.35, fontWeight: 600, color: "#6B5A2E",
          fontStyle: "italic", marginBottom: 14,
        }}>
          Inaugural Museum Night pairs a live jazz quartet with the museum&apos;s abstract expressionist collection for one evening only
        </div>

        <div style={{ fontSize: 12.5, lineHeight: 1.55, color: "#1F1F1F", marginBottom: 10 }}>
          <span style={{ fontWeight: 700, textTransform: "uppercase", letterSpacing: ".02em" }}>CHICAGO, IL — </span>
          The Halden Museum today announced Jazz & Abstracts: A Museum Night, an after-hours program pairing live performance from the Halden Quartet with guided walks through the museum&apos;s abstract expressionist galleries on Friday, May 9.
        </div>

        <div style={{ display: "grid", gap: 5, marginBottom: 12 }}>
          {[100, 96, 92, 98, 70].map((w, i) => (
            <div key={i} style={{ height: 5, borderRadius: 2, background: "#EDE4CB", width: `${w}%` }}/>
          ))}
        </div>

        <div style={{
          padding: "10px 12px",
          borderLeft: "3px solid var(--mpp-accent)",
          background: "#FFF5E4",
          fontSize: 12, lineHeight: 1.45, color: "#1F1F1F",
          fontStyle: "italic", marginBottom: 12,
        }}>
          &ldquo;We wanted an evening where the paintings and the music argue with each other a little,&rdquo;
          {" "}said <span style={{ fontStyle: "normal", fontWeight: 700 }}>— Dr. Miriam Halden</span>, Museum Director.
        </div>

        <div style={{
          display: "flex", alignItems: "center", gap: 12,
          paddingTop: 10, borderTop: "1px solid #EDE4CB",
          fontSize: 10.5, color: "#6B5A2E", fontFamily: "Manrope, system-ui, sans-serif",
        }}>
          <div>
            <div style={{ fontWeight: 800, letterSpacing: ".08em", textTransform: "uppercase", color: "#0F172A" }}>Media Contact</div>
            <div style={{ marginTop: 2 }}>press@eventvesta.com · (312) 555-0117</div>
          </div>
          <div style={{
            marginLeft: "auto",
            display: "inline-flex", alignItems: "center", gap: 5,
            padding: "4px 9px", borderRadius: 999,
            background: "var(--mpp-accent-soft)", color: "var(--mpp-accent)",
            fontSize: 10, fontWeight: 800, letterSpacing: ".08em", textTransform: "uppercase",
          }}>
            <Icon name="check" size={10} stroke={3}/> AP Style
          </div>
        </div>

        <div style={{ textAlign: "center", fontSize: 11, fontWeight: 700, color: "#8E3215", marginTop: 10, letterSpacing: ".3em" }}>
          — 30 —
        </div>
      </div>
    </div>

    {/* Distribution chip (top-right) */}
    <div style={{
      position: "absolute", top: 102, right: -26, zIndex: 4,
      padding: "10px 12px",
      background: "rgba(50,38,5,.80)",
      backdropFilter: "blur(14px)", WebkitBackdropFilter: "blur(14px)",
      border: "1px solid rgba(255,255,255,.14)",
      borderRadius: 10, color: "#fff",
      whiteSpace: "nowrap",
      boxShadow: "0 10px 28px rgba(0,0,0,.28)",
      animation: "vsFloat 8s ease-in-out -1s infinite",
    }}>
      <div style={{ fontSize: 10, fontWeight: 600, opacity: .7, letterSpacing: ".08em", textTransform: "uppercase" }}>Distribution</div>
      <div style={{ fontSize: 17, fontWeight: 800, letterSpacing: "-.02em", marginTop: 2 }}>
        218 outlets <span style={{ fontSize: 11, fontWeight: 700, color: "#E6DB8A" }}>local + trade</span>
      </div>
    </div>

    {/* Format chip (bottom-right) */}
    <div style={{
      position: "absolute", bottom: 24, right: -46, zIndex: 4,
      padding: "10px 12px",
      background: "rgba(255,255,255,.96)",
      borderRadius: 10,
      boxShadow: "0 14px 32px rgba(60,45,5,.26)",
      display: "flex", alignItems: "center", gap: 10,
      animation: "vsFloat 7s ease-in-out -2s infinite",
    }}>
      <div style={{
        width: 30, height: 30, borderRadius: 8,
        background: "linear-gradient(135deg, var(--mpp-accent-soft), rgba(153,153,0,.12))",
        display: "flex", alignItems: "center", justifyContent: "center",
        color: "var(--mpp-accent)",
      }}>
        <Icon name="layers" size={15} stroke={2.2}/>
      </div>
      <div style={{ lineHeight: 1.15 }}>
        <div style={{ fontSize: 10.5, fontWeight: 600, color: "#64748B", letterSpacing: ".06em", textTransform: "uppercase" }}>Formats ready</div>
        <div style={{ fontSize: 12.5, fontWeight: 700, color: "#0F172A" }}>Email · Web · Wire</div>
      </div>
    </div>
  </div>
)

export default PressReleaseDocument
